export abstract class MetricsService {
  public static readonly USER_ACTIVITIES_EVENT = "user-activities";
  public static readonly SESSION_PROLONG_TIME_EVENT = "session-prolong-event";

  public abstract log(trackingEvent: any): void;
  public abstract onDestroy(): void;
}
